import basketApi from "../basket/apiClient";
import events from "../events";
import { currencySwitcher } from "../product-page/currencySwitcher";
import formatPrice from "../utils/formatPrice";
import { imageZoom } from "../utils/image-zoom";
import { lazyLoader } from "../utils/lazy-loader";
import { pushObjectToState } from "../utils/push-state";
import './notification.scss';
import SingleStampApiClient from "./SingleStampApiClient";
const apiClient = new SingleStampApiClient();
const defaultCountry = "Norge";
const defaultCatalogNorway = "NK";
const defaultCatalog = "AFA";
const defaultCatalogNr = "1";
;
export function singleStampList(data) {
    return {
        items: [],
        productCount: 0,
        selectedItems: {},
        isLoadingProducts: false,
        isAddingToCart: false,
        catalogNames: data.catalogNames,
        catalogTranslations: data.catalogTranslations,
        countries: data.countries,
        countryCategories: data.countryCategories,
        description: data.description,
        guid: data.guid,
        parentId: data.parentId,
        title: data.title,
        /* FILTER */
        currentCountry: data.defaultCountry,
        currentCategory: data.defaultCategory,
        currentCatalog: data.defaultCatalog,
        catalogNrA: data.defaultCatalogNr,
        countryList: data.countries,
        catalogList: data.catalogNames,
        previousSelectedFilters: {
            catalogNrA: data.defaultCatalogNr,
            currentCountry: data.defaultCountry,
            currentCategory: data.defaultCategory,
            currentCatalog: data.defaultCatalog,
        },
        notificationOpen: false,
        isPopState: false,
        /* UTILITIES */
        lazyLoader: lazyLoader(),
        currencySwitcher: currencySwitcher(),
        imageZoom: imageZoom(),
        get totalPrice() {
            let total = 0;
            for (const item of Object.values(this.selectedItems)) {
                if (item.price !== null) {
                    total += item.price;
                }
            }
            if (!this.currencySwitcher.isNok) {
                this.currencySwitcher.refreshForeignPriceText(total);
            }
            return total;
        },
        get totalPriceText() {
            return formatPrice(this.totalPrice);
        },
        get categoryList() {
            return this.countryCategories[this.currentCountry.toLowerCase()];
        },
        init() {
            this.currencySwitcher.currencySwitcherInit();
            this.lazyLoader.limit = 40;
            this.triggerFilter().then(() => {
                this.lazyLoader.fetchRequest = () => this.triggerFilter({ take: this.lazyLoader.limit, skip: this.lazyLoader.offset }, true);
                // @ts-ignore
                setTimeout(() => this.lazyLoader.lazyInit(this.$refs["scrollTarget"]), 100);
            });
            events.singleStampItemSelected.subscribe((data) => {
                if (data.isSelected) {
                    this.selectedItems[data.sku] = {
                        price: data.price,
                        input: data.inputElement,
                    };
                }
                else {
                    delete this.selectedItems[data.sku];
                }
            });
            events.onPopState.subscribe(state => {
                this.isPopState = true;
                this.currentCountry = state.country;
                this.currentCategory = state.category;
                this.currentCatalog = state.catalog;
                this.catalogNrA = state.catalogNumberA;
                this.lazyLoader.offset = 0;
                this.triggerFilter();
            });
        },
        async getStamps(filterData, isLazy) {
            this.isLoadingProducts = true;
            this.selectedItems = !isLazy ? {} : { ...this.selectedItems };
            const fetchBool = isLazy ? this.productCount >= this.lazyLoader.limit : true;
            try {
                if (fetchBool) {
                    var response = await apiClient.getStamps(filterData);
                    if (!isLazy) {
                        this.items = [];
                    }
                    if (response.groups.length > 0) {
                        response.groups.forEach((group) => {
                            const item = defineQualities(group);
                            if (isLazy) {
                                const found = this.items.find((i) => i.name === item.name);
                                if (found) {
                                    found.items.push(...item.items);
                                }
                                else {
                                    this.items.push(item);
                                }
                            }
                            else {
                                this.items.push(item);
                            }
                        });
                        this.productCount = response.total;
                    }
                    else {
                        this.productCount = 0;
                        this.lazyLoader.offset = this.productCount + this.lazyLoader.limit;
                    }
                }
            }
            finally {
                this.isLoadingProducts = false;
                this.lazyLoader.isLazyLoading = false;
            }
        },
        buyAllSelected() {
            const skus = [];
            for (const sku of Object.keys(this.selectedItems)) {
                if (this.selectedItems[sku]) {
                    skus.push(sku);
                }
            }
            const data = skus
                .map((sku) => sku.split("-"))
                .reduce((grouped, skus) => {
                let item = grouped.find((itm) => itm.sku === skus[0]);
                if (!item) {
                    item = {
                        sku: skus[0],
                        quantity: 1,
                        variants: [],
                    };
                    grouped.push(item);
                }
                item.variants.push(skus[1]);
                return grouped;
            }, []);
            this.isAddingToCart = true;
            basketApi
                .addItems(data)
                .then((basket) => {
                events.onBasketUpdated.trigger({ products: data, basket });
            })
                .finally(() => {
                this.isAddingToCart = false;
                this.deselectAllStamps();
            });
        },
        onItemSelected(event, subItemSku, { sku: qualitySku, price }) {
            const isSelected = event.target.checked;
            const sku = `${subItemSku}-${qualitySku}`;
            events.singleStampItemSelected.trigger({
                isSelected,
                sku,
                price,
                inputElement: event.target,
            });
        },
        deselectAllStamps() {
            for (const item of Object.values(this.selectedItems)) {
                item.input.checked = false;
            }
            this.selectedItems = {};
        },
        updateFilterValue(key, value) {
            var _a;
            this.setPreviousFilters();
            // @ts-ignore
            this[key] = value;
            if (key === 'currentCountry') {
                // @ts-ignore
                this.currentCategory = this.categoryList[0];
                this.currentCatalog =
                    (_a = (value == defaultCountry
                        ? this.catalogList.find(x => x == defaultCatalogNorway)
                        : this.catalogList.find(x => x == defaultCatalog))) !== null && _a !== void 0 ? _a : this.catalogList[0];
            }
            if (key !== "catalogNrA") {
                this.catalogNrA = defaultCatalogNr;
            }
            this.search();
        },
        setPreviousFilters() {
            this.previousSelectedFilters.currentCountry = this.currentCountry;
            this.previousSelectedFilters.currentCategory = this.currentCategory;
            this.previousSelectedFilters.currentCatalog = this.currentCatalog;
            this.previousSelectedFilters.catalogNrA = this.catalogNrA;
        },
        search() {
            if (Object.keys(this.selectedItems).length !== 0) {
                this.openNotification();
            }
            else {
                this.lazyLoader.limit = 40;
                this.lazyLoader.offset = 0;
                this.triggerFilter();
            }
        },
        // @ts-ignore
        triggerFilter(details = { skip: this.lazyLoader.offset, take: this.lazyLoader.limit }, isLazy = false) {
            let catalogA;
            let catalogB;
            if (this.catalogNrA.indexOf(' ') >= 1) {
                catalogA = this.catalogNrA.split(' ')[0];
                catalogB = this.catalogNrA.split(' ')[1];
            }
            else {
                catalogA = this.catalogNrA;
            }
            if (!isLazy && !this.isPopState) {
                pushObjectToState({
                    country: this.currentCountry,
                    category: this.currentCategory,
                    catalog: this.currentCatalog,
                    catalogNumberA: this.catalogNrA,
                });
            }
            this.isPopState = false;
            return this.getStamps({
                catalog: this.currentCatalog,
                catalogNumberA: catalogA !== null && catalogA !== void 0 ? catalogA : '',
                catalogNumberB: catalogB !== null && catalogB !== void 0 ? catalogB : '',
                country: this.currentCountry,
                category: this.currentCategory,
                ...details,
            }, isLazy);
        },
        resetFilter() {
            Object.keys(this.previousSelectedFilters).forEach((key) => {
                // @ts-ignore
                this[key] = this.previousSelectedFilters[key];
            });
        },
        /* NOTIFICATION */
        updateModalState(open) {
            this.notificationOpen = open;
            events.setBackdrop.trigger(open);
        },
        openNotification() {
            this.updateModalState(true);
        },
        close() {
            this.updateModalState(false);
            this.resetFilter();
        },
        closeAndAdd() {
            this.updateModalState(false);
            this.resetFilter();
            this.buyAllSelected();
        },
        closeAndClear() {
            this.updateModalState(false);
            this.resetFilter();
            this.deselectAllStamps();
        },
        closeAndTriggerFilter() {
            this.updateModalState(false);
            this.triggerFilter();
        }
    };
}
function defineQualities({ name, items }) {
    return {
        name,
        items: items.map(({ variants, ...props }) => {
            const mint = variants.find((v) => v.quality === "Postfrisk");
            const unused = variants.find((v) => v.quality === "Ubrukt");
            const stamped = variants.find((v) => v.quality === "Stemplet");
            return {
                ...props,
                quality: {
                    mint: createVariant(mint),
                    unused: createVariant(unused),
                    stamped: createVariant(stamped),
                }
            };
        })
    };
}
function createVariant(variant) {
    return variant ? {
        ...variant,
        selected: false,
        priceText: formatPrice(variant.price),
    } : { selected: false };
}
